import * as Yup from "yup";

const phoneSchema = Yup.string()
  .trim()
  .required("Phone number is required")
  .min(7, "Enter a valid phone number")
  .max(30, "Phone number is too long");

const emailSchema = Yup.string()
  .trim()
  .email("Enter a valid email address")
  .required("Email is required");

export const loginSchema = Yup.object({
  email: emailSchema,
  password: Yup.string().required("Password is required"),
  rememberMe: Yup.boolean(),
});

export const registerSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Full name is required")
    .min(2, "Name must be at least 2 characters")
    .max(120, "Name is too long"),
  phone: phoneSchema,
  email: emailSchema,
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(128, "Password is too long"),
  confirmPassword: Yup.string()
    .required("Please confirm your password")
    .oneOf([Yup.ref("password")], "Passwords do not match"),
});

export const forgotPasswordSchema = Yup.object({
  email: emailSchema,
});

export const resetPasswordSchema = Yup.object({
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(128, "Password is too long"),
  confirmPassword: Yup.string()
    .required("Please confirm your password")
    .oneOf([Yup.ref("password")], "Passwords do not match"),
});

export const quoteSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Full name is required")
    .min(2, "Name must be at least 2 characters"),
  company: Yup.string().trim().max(200, "Company name is too long"),
  phone: phoneSchema,
  email: emailSchema,
  category: Yup.string().required("Please select a category"),
  quantity: Yup.string().trim().max(100, "Quantity is too long"),
  location: Yup.string().trim().max(200, "Location is too long"),
  message: Yup.string()
    .trim()
    .required("Requirement details are required")
    .min(5, "Please provide a bit more detail")
    .max(5000, "Message is too long"),
});

export const checkoutSchema = Yup.object({
  fullName: Yup.string()
    .trim()
    .required("Full name is required")
    .min(2, "Name must be at least 2 characters")
    .max(120, "Name is too long"),
  email: emailSchema,
  phone: phoneSchema,
  companyName: Yup.string().trim().max(200, "Company name is too long"),
  line1: Yup.string()
    .trim()
    .required("Delivery address is required")
    .min(5, "Please enter a complete delivery address")
    .max(500, "Address is too long"),
  line2: Yup.string().trim().max(300, "Address line is too long"),
  city: Yup.string()
    .trim()
    .required("City is required")
    .min(2, "City is required")
    .max(120, "City name is too long"),
  emirate: Yup.string().required("Please select an emirate"),
  country: Yup.string().oneOf(
    ["United Arab Emirates"],
    "Delivery is available in the United Arab Emirates only"
  ),
  notes: Yup.string().trim().max(2000, "Notes are too long"),
});

export const contactSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Full name is required")
    .min(2, "Name must be at least 2 characters"),
  email: emailSchema,
  phone: phoneSchema,
  message: Yup.string()
    .trim()
    .required("Message is required")
    .min(5, "Please provide a bit more detail")
    .max(5000, "Message is too long"),
});
